import {sortBy, reverse} from 'lodash/fp';
import * as O from 'optics-ts';
import {pipe} from 'ts-opt';

import {MatingResult} from 'api/gen/MatingResult';
import {ScoringResult} from 'api/gen/ScoringResult';

const resultsO = O.optic<MatingResult>().prop('results').elems();

const sortBullsInScoringResult = (scoringResult: ScoringResult): ScoringResult => ({
    earTag: scoringResult.earTag,
    bulls: pipe(scoringResult.bulls, sortBy(x => x.score), reverse),
});

/**
 * Sorts bulls inside each scoring result row by score descending.
 *
 * @param result Mating result with unsorted bull rows.
 * @returns A mating result with each row sorted by bull score.
 */
export const getSortedMatingResult = O.modify(resultsO)(sortBullsInScoringResult);
